module.exports = __webpack_public_path__ + "media/newstyle/images/icon-twitter-purple-ebb89109bdb2c731f1b4bff70c3c6de0.svg";